import { combineReducers } from 'redux';
import { reducer as application } from './slices/application';
import { reducer as auth } from './slices/auth';

const rootReducer = combineReducers({
    auth,
    application,
});

export default rootReducer;
